// @ts-nocheck
import * as types from '../types';
import { CASHOUT_BLOCK_MARKETS_CHANGED, CASHOUT_BLOCK_TOURNAMENTS_CHANGED } from '../types';

const initialState = {
    statusesList: [],
    cityAndRegions: [],
    ticketSubStatusesList: [],
    competitionTypesList: [],
    sportsList: [],
    categoriesList: [],
    sportsMarketsList: [],
    tournamentsList: [],
    eventsList: [],
    marketsList: [],
    outcomesList: [],
    specifiersList: [],
    clientTypes: [],
    eventSearchResults: [],
    activeEventsList: [],
    activities: [],
    balanceActivities: [],
    groupByOptions: {},
    actionTypes: [],
    operationTypes: [],
    conditionTypes: [],
    paymentMethods: [],
    paymentProviders: [],
    sources: [],
    withdrawalRuleConditions: [],
    playerMassUpdateActionTypes: [],
    userStatus: [],
    freezeTypes: [],
    walletTypes: [],
    channels: [],
    playerSegmentFilterTypes: [],
    archiveStatuses: [],
    communicationCategories: [],
    communicationChannels: [],
    communicationDirections: [],
    messageStatuses: [],
    noteCategories: [],
    logTypes: [],
    ticketOperationTypes: [],
    ticketOperationStatuses: [],
    usedTournamentsList: [],
    usedMarketsList: [],
};

const staticData = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case types.STATIC_STATUSES_CHANGED: {
            return {
                ...state,
                statusesList: payload,
            };
        }
        case types.STATIC_CITY_AND_REGION_CHANGED: {
            return {
                ...state,
                cityAndRegions: payload,
            };
        }
        case types.STATIC_TICKET_SUB_STATUSES_CHANGED: {
            return {
                ...state,
                ticketSubStatusesList: payload.filter(status => status.key !== 3 && status.key !== 8),
            };
        }
        case types.STATIC_COMPETITION_TYPES_CHANGED: {
            return {
                ...state,
                competitionTypesList: payload,
            };
        }
        case types.STATIC_SPORTS_CHANGED: {
            return {
                ...state,
                sportsList: payload,
            };
        }
        case types.STATIC_SPORTS_MARKETS_CHANGED: {
            return {
                ...state,
                sportsMarketsList: payload,
            };
        }
        case types.STATIC_CATEGORIES_CHANGED: {
            return {
                ...state,
                categoriesList: payload,
            };
        }
        case types.STATIC_TOURNAMENTS_CHANGED: {
            return {
                ...state,
                tournamentsList: payload,
            };
        }
        case types.STATIC_EVENTS_CHANGED: {
            return {
                ...state,
                eventsList: payload,
            };
        }
        case types.STATIC_ACTIVE_EVENTS_CHANGED: {
            return {
                ...state,
                activeEventsList: payload,
            };
        }
        case types.STATIC_MARKETS_CHANGED: {
            return {
                ...state,
                marketsList: payload,
            };
        }
        case types.STATIC_OUTCOMES_CHANGED: {
            return {
                ...state,
                outcomesList: payload,
            };
        }
        case types.STATIC_SPECIFIERS_CHANGED: {
            return {
                ...state,
                specifiersList: payload,
            };
        }
        case types.CLIENT_TYPES_CHANGED: {
            return {
                ...state,
                clientTypes: payload,
            };
        }
        case types.STATIC_EVENT_SEARCH_RESULTS_CHANGED: {
            return {
                ...state,
                eventSearchResults: payload,
            };
        }
        case types.STATIC_ACTION_TYPES_CHANGED: {
            return {
                ...state,
                actionTypes: payload,
            };
        }
        case types.STATIC_PAYMENT_METHODS_CHANGED: {
            return {
                ...state,
                paymentMethods: payload,
            };
        }
        case types.STATIC_PAYMENT_PROVIDERS_CHANGED: {
            return {
                ...state,
                paymentProviders: payload,
            };
        }
        case types.STATIC_SOURCES_CHANGED: {
            return {
                ...state,
                sources: payload,
            };
        }
        case types.STATIC_CONDITION_TYPES_CHANGED: {
            return {
                ...state,
                conditionTypes: payload,
            };
        }
        case types.STATIC_OPERATION_TYPES_CHANGED: {
            return {
                ...state,
                operationTypes: payload,
            };
        }
        case types.STATIC_WITHDRAWAL_RULE_CONDITIONS_CHANGED: {
            return {
                ...state,
                withdrawalRuleConditions: payload,
            };
        }
        case types.STATIC_USER_STATUS_CHANGED: {
            return {
                ...state,
                userStatus: payload,
            };
        }
        case types.STATIC_FREEZE_TYPE_CHANGED: {
            return {
                ...state,
                freezeTypes: payload,
            };
        }
        case types.STATIC_WALLET_TYPE_CHANGED: {
            return {
                ...state,
                walletTypes: payload,
            };
        }
        case types.STATIC_PLAYER_MASS_UPDATE_ACTION_TYPES_CHANGED: {
            return {
                ...state,
                playerMassUpdateActionTypes: payload,
            };
        }
        case types.STATIC_ACTIVITIES_CHANGED: {
            return {
                ...state,
                activities: payload,
            };
        }
        case types.STATIC_BALANCE_ACTIVITIES_CHANGED: {
            return {
                ...state,
                balanceActivities: payload,
            };
        }
        case types.STATIC_GROUPBY_OPTIONS_CHANGED: {
            return {
                ...state,
                groupByOptions: payload,
            };
        }
        case types.STATIC_GROUPBY_OPTIONS_CLEARED: {
            return {
                ...state,
                groupByOptions: initialState.groupByOptions,
            };
        }
        case types.STATIC_CHANNEL_RECEIVED: {
            return {
                ...state,
                channels: payload,
            };
        }
        case types.STATIC_PLAYER_SEGMENT_FILTER_TYPES_CHANGED: {
            return {
                ...state,
                playerSegmentFilterTypes: payload,
            };
        }
        case types.STATIC_ARCHIVE_STATUSES_CHANGED: {
            return {
                ...state,
                archiveStatuses: payload,
            };
        }
        case types.STATIC_COMMUNICATION_CHANNELS_CHANGED: {
            return {
                ...state,
                communicationChannels: payload,
            };
        }
        case types.STATIC_COMMUNICATION_CATEGORIES_CHANGED: {
            return {
                ...state,
                communicationCategories: payload,
            };
        }
        case types.STATIC_COMMUNICATION_DIRECTIONS_CHANGED: {
            return {
                ...state,
                communicationDirections: payload,
            };
        }
        case types.STATIC_MESSAGE_STATUSES_CHANGED: {
            return {
                ...state,
                messageStatuses: payload,
            };
        }
        case types.STATIC_NOTE_CATEGORIES_CHANGED: {
            return {
                ...state,
                noteCategories: payload,
            };
        }
        case types.STATIC_LOG_TYPES_CHANGED: {
            return {
                ...state,
                logTypes: payload,
            };
        }
        case types.STATIC_TICKET_OPERATION_TYPES_CHANGED: {
            return {
                ...state,
                ticketOperationTypes: payload,
            };
        }
        case types.STATIC_TICKET_OPERATION_STATUSES_CHANGED: {
            return {
                ...state,
                ticketOperationStatuses: payload,
            };
        }

        case types.CASHOUT_BLOCK_TOURNAMENTS_CHANGED: {
            return {
                ...state,
                usedTournamentsList: payload || [],
            };
        }
        case types.CASHOUT_BLOCK_MARKETS_CHANGED: {
            return {
                ...state,
                usedMarketsList: payload || [],
            };
        }

        default:
            return state;
    }
};

export default staticData;
